import { OperationVariables, QueryResult, useQuery } from '@apollo/client';
import GET_ASSESSMENT_REPORT from 'graph/queries/assessment-report/get-assessment-report';
import { AssessmentReport } from 'types';

export type AssessmentReportStoreState = {
  assessmentReport?: AssessmentReport;
  isLoading: boolean;
};

export type AssessmentReportStoreDispatch = {
  AssessmentReportRefetch: any;
};
export type AssessmentReportStore = [AssessmentReportStoreState, AssessmentReportStoreDispatch];

const useAssessmentReportStore = (variables?: OperationVariables): AssessmentReportStore => {
  const {
    data,
    loading,
    refetch: AssessmentReportRefetch,
  }: QueryResult<{ assessmentReport: AssessmentReport }> = useQuery(GET_ASSESSMENT_REPORT, {
    fetchPolicy: 'no-cache',
    variables,
  });

  return [
    {
      assessmentReport: data?.assessmentReport,
      isLoading: loading,
    },
    {
      AssessmentReportRefetch,
    },
  ];
};

export default useAssessmentReportStore;
